import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.css']
})
export class TagListComponent {
  @Input() tagString: string;

  get tags() {
    if (this.tagString == null) return [];
    return this.tagString.split(',').map(tag => tag.trim());
;
  }


}
